namespace $ {
	/** Catalogue folder: navigation only, never a module or an FQN namespace. */
	export class $shm_hitalama_components_folder extends $giper_baza_entity.with({
		Parent: $giper_baza_atom_text,
	}) {}
}
